export const $black = '#000000'
export const $monoGray = '#808080'
export const $white = '#FFFFFF'

export const $neutralGray100 = '#161616'
export const $neutralGray90 = '#262626'
export const $neutralGray80 = '#393939'
export const $neutralGray70 = '#525252'
export const $neutralGray60 = '#6F6F6F'
export const $neutralGray50 = '#8D8D8D'
export const $neutralGray40 = '#A8A8A8'
export const $neutralGray30 = '#C6C6C6'
export const $neutralGray20 = '#E0E0E0'
export const $neutralGray10 = '#F4F4F4'

export const $red100 = '#2E0808'
export const $red90 = '#540909'
export const $red80 = '#780505'
export const $red70 = '#AB0303'
export const $red60 = '#E11D48'
export const $red50 = '#FB4B4B'
export const $red40 = '#FF7676'
export const $red30 = '#FFA4A4'
export const $red20 = '#FCD0D0'
export const $red10 = '#FFF0F0'

export const $yellow30 = '#FFCD06'
export const $yellow20 = '#FFDC52'
export const $yellow10 = '#FFF6D1'

export const $green100 = '#081B09'
export const $green90 = '#01330F'
export const $green80 = '#054719'
export const $green70 = '#10642A'
export const $green60 = '#198038'
export const $green50 = '#24A148'
export const $green40 = '#3DBB61'
export const $green30 = '#56D679'
export const $green20 = '#9DEEB2'
export const $green10 = '#DAFBE4'

export const $teal100 = '#081A1C'
export const $teal90 = '#003137'
export const $teal80 = '#004548'
export const $teal70 = '#006161'
export const $teal60 = '#007D79'
export const $teal50 = '#009C98'
export const $teal40 = '#00BAB6'
export const $teal30 = '#20D5D2'
export const $teal20 = '#92EEEE'
export const $teal10 = '#DBFBFB'

export const $cyan100 = '#061727'
export const $cyan90 = '#012749'
export const $cyan80 = '#003A6D'
export const $cyan70 = '#00539A'
export const $cyan60 = '#0072C3'
export const $cyan50 = '#1192E8'
export const $cyan40 = '#33B1FF'
export const $cyan30 = '#82CFFF'
export const $cyan20 = '#BAE6FF'
export const $cyan10 = '#E5F6FF'

export const $blue100 = '#051243'
export const $blue90 = '#061F80'
export const $blue80 = '#0530AD'
export const $blue70 = '#054ADA'
export const $blue60 = '#0062FF'
export const $blue50 = '#408BFC'
export const $blue40 = '#6EA6FF'
export const $blue30 = '#97C1FF'
export const $blue20 = '#C9DEFF'
export const $blue10 = '#EDF4FF'

export const $purple100 = '#1C0F30'
export const $purple90 = '#31135E'
export const $purple80 = '#491D8B'
export const $purple70 = '#6929C4'
export const $purple60 = '#8A3FFC'
export const $purple50 = '#A56EFF'
export const $purple40 = '#BE95FF'
export const $purple30 = '#D4BBFF'
export const $purple20 = '#E8DAFF'
export const $purple10 = '#F6F2FF'

export const $magenta100 ='#2A0A16'
export const $magenta90 = '#57002B'
export const $magenta80 = '#760A3A'
export const $magenta70 = '#A11950'
export const $magenta60 = '#D12765'
export const $magenta50 = '#EE538B'
export const $magenta40 = '#FA75A6'
export const $magenta30 = '#FFA0C2'
export const $magenta20 = '#FFCFE1'
export const $magenta10 = '#FFF0F6'
